import GenerateEnum from '../generateEnum'
import { getLabelText } from '../utils'

// 状态，0 禁用
// 1 启用
// 2 待设置密码
export const creditStateEnum = GenerateEnum({
  CLOSE: {
    value: 0,
    label: getLabelText({ key: 'remote.common.close', text: '关闭' })
  },
  OPEN: {
    value: 1,
    label: getLabelText({ key: 'remote.common.open2', text: '开启' })
  }
  /*WAIT_SET_PWD: {
                                            value: 2,
                                            label: '待设置密码'
                                          }*/
})

// USD,EUR,CNY
// 账户类型
//          ■ 人民币开通额度
//         ■ 美元开通额度
//         ■ 欧元开通额度
export const creditCurrencyEnum = GenerateEnum({
  CNY: {
    value: 'CNY',
    label: getLabelText({
      key: 'remote.common.rmbCreditPayment',
      text: '人民币信用支付',
    }),
    currency: getLabelText({ key: 'remote.common.rmb', text: '人民币' }),
    symbol: '￥',
    detail:
      getLabelText({
        key: 'remote.common.rmbCreditPayment',
        text: '人民币信用支付',
      }) +
      `（${getLabelText({
        key: 'remote.common.onlySupportsServiceFeeInRmb',
        text: '仅支持服务费人民币币种订单',
      })}）`
  },
  USD: {
    value: 'USD',
    label: getLabelText({
      key: 'remote.common.paymentByCreditInUsDollars',
      text: '美元信用支付',
    }),
    currency: getLabelText({ key: 'remote.common.dollar', text: '美元' }),
    symbol: '$',
    detail:
      getLabelText({
        key: 'remote.common.paymentByCreditInUsDollars',
        text: '美元信用支付',
      }) +
      `（${getLabelText({
        key: 'remote.common.onlySupportsOfficialFeeInUsd',
        text: '仅支持官费美元币种订单',
      })}）`
  },
  EUR: {
    value: 'EUR',
    label: getLabelText({
      key: 'remote.common.euroCreditPayment',
      text: '欧元信用支付',
    }),
    currency: getLabelText({ key: 'remote.common.euro', text: '欧元' }),
    symbol: '€',
    detail:
      getLabelText({
        key: 'remote.common.euroCreditPayment',
        text: '欧元信用支付',
      }) +
      `（${getLabelText({
        key: 'remote.common.onlySupportsOfficialFeeInEur',
        text: '仅支持官费欧元币种订单',
      })}）`
  }
})

// 还款状态 待还款、已还款、还款中、已退款（仅admin显示）
export const creditRepaymentStateEnum = GenerateEnum({
  WAIT: {
    value: 0,
    label: getLabelText({ key: 'remote.common.toBeRepaid', text: '待还款' })
  },
  REPAYING: {
    value: 1,
    label: getLabelText({
      key: 'remote.common.repaymentInProgress',
      text: '还款中',
    })
  },
  PAID: {
    value: 2,
    label: getLabelText({ key: 'remote.common.repaid', text: '已还款' })
  },
  REFUND: {
    value: 3,
    label: getLabelText({ key: 'remote.common.refunded', text: '已退款' })
  },
  NOTSUPPORT: {
    value: 4,
    label: getLabelText({
      key: 'remote.common.notSupportRepayment',
      text: '暂不支持还款',
    })
  }
})

/*
0：商户端：待支付， 后台：无
1：商户端：已完成， 后台：已完成
2：商户端：已取消， 后台：无
3：商户端：还款失败， 后台：失败
4：商户端：还款中， 后台：处理中
 */
// 还款单状态，处理中、已完成、失败
export const repaymentOrderStateEnum = GenerateEnum({
  WAIT: {
    value: 0,
    user: getLabelText({ key: 'remote.common.toBePaid3', text: '待支付' }),
    admin: '-',
  },
  COMPLETED: {
    value: 1,
    user: getLabelText({ key: 'remote.common.completed', text: '已完成' }),
    admin: getLabelText({ key: 'remote.common.completed', text: '已完成' })
  },
  CANCEL: {
    value: 2,
    user: getLabelText({ key: 'remote.common.cancelled', text: '已取消' }),
    admin: '-',
  },
  FAILED: {
    value: 3,
    user: getLabelText({
      key: 'remote.common.repaymentFailed',
      text: '还款失败',
    }),
    admin: getLabelText({ key: 'remote.common.failure', text: '失败' })
  },
  CONFIRMING: {
    value: 4,
    user: getLabelText({
      key: 'remote.common.repaymentInProgress',
      text: '还款中',
    }),
    admin: getLabelText({ key: 'remote.common.processing', text: '处理中' })
  }
})

// creditAccount，信用账号状态：-1：历史没开通过。0：当前关闭。1：当前开通
export const creditAccountEnum = GenerateEnum({
  HISTORY_DISABLED: {
    value: -1,
    label: '历史未开通',
  },
  DISABLED: {
    value: 0,
    label: getLabelText({ key: 'remote.common.close', text: '关闭' })
  },
  ENABLED: {
    value: 1,
    label: getLabelText({ key: 'remote.common.open2', text: '开启' })
  }
})



// WEBPACK FOOTER //
// /data/.jenkins/workspace/ost-prod/@ost/lib/enum/creditCard.js